export default {
  t1: '中国铁道科学研究院集团有限公司 | 京ICP备20012158号-2',
  t2: 'Copyright© 2024 | 中国铁道科学研究院集团有限公司 版权所有 | 严禁涉及国家机密内容上网',
  t3: '常见问题',
  t4: '服务指南',
  t5: '网站地图',
  t6: '门户网站',
  t7: '内部邮箱',
  t8: '安全提示'
}
